import styled from 'styled-components';

export const Item = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const IconContainer = styled.span`
  display: inline-block;
  margin-left: 3px;
  margin-right: 3px;
`;

export const Container = styled.div`
  display: flex;
`;
